import React, { useState } from 'react'
import { useField, useFormikContext } from 'formik'

import { Form, Input } from '@sketch/components'

import { uniqueId } from '@sketch/utils'

interface FormFieldProps<F> {
  name: F
  label: string
  placeholder?: string
  help?: string
  disabled?: boolean
  autoComplete?: HTMLInputElement['autocomplete']
}

function FormField<F extends {}>(props: FormFieldProps<keyof F & string>) {
  const [inputUniqueId] = useState(uniqueId('formfield'))

  const { placeholder, label, help, name, disabled, autoComplete } = props
  const [field, meta] = useField({ name })
  const { submitCount } = useFormikContext()

  const showError =
    meta.touched &&
    (submitCount > 0 || (typeof field.value === 'string' && field.value))

  return (
    <Form.Field
      id={inputUniqueId}
      label={label}
      help={help}
      errorText={showError ? meta.error : undefined}
    >
      <Input
        placeholder={placeholder}
        type="text"
        disabled={disabled}
        {...field}
        value={field.value || ''}
        autoComplete={autoComplete}
      />
    </Form.Field>
  )
}
export default FormField
